// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1ap-S","container":"styles_container__3dRSo","pdfWrapper":"styles_pdfWrapper__29rCD","pageWrapper":"styles_pageWrapper__396MC"};